export interface ProductAttribute {
	key: string;
	value: string;
	group: string;
}

export interface ProductDetailsResponse {
	displayAttributes: ProductAttribute[];
	productInfo: string;
}

export async function fetchProductDetails(
	matnr: string
): Promise<ProductDetailsResponse> {
	const response = await fetch(`/configure/api/productDetails/${matnr}`, {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
		},
	});

	if (!response.ok) {
		throw new Error(`Failed to fetch product details: ${response.statusText}`);
	}

	const data = await response.json();
	return data;
}
